var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTripLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 26,
    viewBox: "0 0 2 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0L0.5 2.16667H1.5V0L0.5 0ZM0.5 6.5L0.5 10.8333H1.5L1.5 6.5H0.5ZM0.5 15.1667L0.5 19.5H1.5L1.5 15.1667H0.5ZM0.5 23.8333L0.5 26H1.5L1.5 23.8333H0.5Z",
    fill: "#081754"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripLine);
export default __webpack_public_path__ + "static/media/tripLine.a3c7734997e45a4aaf7dd722838859f8.svg";
export { ForwardRef as ReactComponent };